import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './Loader.styles';

const Loader = () => {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <div className={classes.loaderWrapper}>
      <CircularProgress color="primary" />
    </div>
  );
};

export default Loader;
